import { safeJsonParse } from './object';

const { localStorage } = window;

export function get(key) {
  return safeJsonParse(localStorage.getItem(key));
}

export function put(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function remove(key) {
  localStorage.removeItem(key);
}
